import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Company } from 'src/app/models/company';
import { CompanyService } from 'src/app/services/company.service';
import { InventoryService } from 'src/app/services/inventory.service';
import { UtilsService } from 'src/app/services/utils.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { StoreService } from 'src/app/services/store.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { ClientService } from 'src/app/services/client.service';
import { RepresentativeService } from 'src/app/services/representative.service';
import { Store } from 'src/app/models/store';
import { Client } from "src/app/models/client";
import { DeliveryService } from 'src/app/services/delivery.service';

interface transferHeader {
  transferOriginStoreCode,
  transferWarehouseCode,
  transferBusinessCode,
  transferDescription,
  transferType,
  transferRazon,
  transOtherRazonDesc

  //auxiliares
  transferName
  transferPhone,
  transferAddress,
  transferAdviser,
  transferTaxDocument,
}

interface transferDetail {
  transferInventoryDetailInventoryCode,
  transferInventoryDetailQuantity,
  transferDetailType,
  description,
  transferNotaSalida,
  transferSucursal,
  //auxiliares
  transferInventoryBussiness
}

interface shipment {
  FechaEmisionNR: string;
  shipmentInternSerial: string;
  TipoTransaccionShipment: string;
  EmailCliente: string;
  NombreCliente: string;
  NaturalezaCliente: string;
  TiOpeCliente: string;
  PaisCliente: string;
  DesPaisCliente: string;
  TipoRec: string;
  TipoRecDesc: string;
  NumDocCliente: string;
  CodCliente: string;
  MotivoEmision: string;
  ResponsableEmision: string;
  KmEstimados: string;
  FechaEmision: string;
  CostoFlete: string;
  ObservacionesEmisor: string;
  InformacionInteresFisico: string;
  NumOrdenCompra: string;
  NumOrdenVenta: string;
  NumAsientoContable: string;
  TipoTransporte: string;
  ModalidadTransporte: string;
  ResponsableCostoFlete: string;
  CondicionNegociacion: string;
  NumManifiesto: string;
  NumDespachoImportacion: string;
  FechaInicioTraslado: string;
  FechaFinTraslado: string;
  PaisDestino: string;
  CallePrincipal: string;
  NumeroCasaSalida: string;
  Telefono: string;
  ComplementoDireccion1: string;
  ComplementoDireccion2: string;
  DeparamentoSalida: string;
  DistritoSalida: string;
  CiudadSalida: string;
  CodDeparamentoSalida: string;
  CodDistritoSalida: string;
  CodCiudadSalida: string;
  CallePrincipalCliente: string;
  NumeroCasaSalidaCliente: string;
  TelefonoCliente: string;
  ComplementoDireccion1Cliente: string;
  ComplementoDireccion2Cliente: string;
  DeparamentoSalidaCliente: string;
  DistritoSalidaCliente: string;
  CiudadSalidaCliente: string;
  CodDeparamentoSalidaCliente: string;
  CodDistritoSalidaCliente: string;
  CodCiudadSalidaCliente: string;
  TipoVehiculo: string;
  Marca: string;
  TipoIdentificacionVehiculo: string;
  ColorVehiculo: string;
  NumeroIdentificacionVehiculo: string;
  NaturalezaTransportista: string;
  NombreRazonEmpresa: string;
  RucEmpresa: string;
  DigitoVerificador: string;
  NacionalidadTransportista: string;
  NumeroDocumentoTransportista: string;
  NombrePilot: string;
  DomicilioFiscalTransportista: string;
  DireccionChofer: string;
  NombreAgente: string;
  RucAgente: string;
  DigitoVerificadorAgente: string;
  DigitoVerificadorCliente: string;
  DireccionAgente: string;
}

@Component({
  selector: 'app-transfer',
  templateUrl: './shipment.component.html',
  styleUrls: ['./shipment.component.scss'],
  providers: [UtilsService, CompanyService, WarehouseService, InventoryService, StoreService, InvoiceService, ClientService, RepresentativeService, DeliveryService]

  // StoreService
})
export class ShipmentComponent implements OnInit {
  // Variables auxiliares
  company = {} as Company;
  transferHeader = {} as transferHeader;
  transferDetail = {} as transferDetail;
  shipment = {} as shipment;
  store = {} as Store;
  client = {} as Client;
  public date: string;
  public userCode: number;
  public storeCode: number;
  public storeName: string;
  public companyCode: number;
  public userName: string;
  public transferCode: number;
  public isEdit: boolean;
  public isDisabled: boolean;
  loading;

  // Variables de Linea de transfer
  public transferLine: any = new Array;
  public addAmount: boolean;
  public stock: number;
  public price: number;
  public total: number;
  public serial: boolean;
  public serialSelected = new Array;
  public Minstock: number;

  // DATA SELECT
  public clientList: any[] = new Array();
  public selectedItemsClient = [];
  public dropdownSettingsCliente = {};

  // DATA SELECT REPRESENTANTE
  public representativeList: any[] = new Array();
  public selectedItemsrepresentative = [];
  public dropdownSettingsRepresentative = {};

  public dropdownSettingsStore = {};

  public inventoryList: any[] = new Array();
  public selectedItems = [];
  public dropdownSettings: IDropdownSettings = {};
  closeDropdownSelection = false;

  public serialList: any[] = new Array();
  public selectedItemsSerial = [];
  public dropdownSettingsSerial: IDropdownSettings = {};
  closeDropdownSelectionSerial = false;

  // DATA SELECT TIPO TRANSFERENCIA
  public transferType: number = 0;
  public transferTypeList: any[] = new Array();
  public selectedItemstransferType = [];
  public dropdownSettingstransferType = {};

  public otherRazon: boolean = false;
  public RefNotaSalida: boolean = false;

  public NombrePilot: string;
  public DPIPilot: string;
  public TelPilot: string;
  public DirPilot: string;

  public MarcaCarro: string;
  public ModeloCarro: string;
  public PlacaCarro: string;
  public ColorCarro: string;

  // DATA SELECT ADDRESS MERCANCIAS
  public idProvincia: number;
  public itemNameProvincia: string;
  public selectedItemsProvincia = [];
  public ProvinciaList: any[] = new Array();
  public dropdownSettingsProvincia: IDropdownSettings = {};
  closeDropdownSelectionProvincia = false;

  public idDistritos: number;
  public itemNameDistritos: string;
  public selectedItemsDistritos = [];
  public DistritosList: any[] = new Array();
  public dropdownSettingsDistritos: IDropdownSettings = {};
  closeDropdownSelectionDistritos = false;

  public idCorregimientos: number;
  public itemNameCorregimientos: string;
  public selectedItemsCorregimientos = [];
  public CorregimientosList: any[] = new Array();
  public dropdownSettingsCorregimientos: IDropdownSettings = {};
  closeDropdownSelectionCorregimientos = false;

  // DATA SELECT ADDRESS CLIENT
  public idProvinciaClient: number;
  public itemNameProvinciaClient: string;
  public selectedItemsProvinciaClient = [];
  public ProvinciaListClient: any[] = new Array();
  public dropdownSettingsProvinciaClient: IDropdownSettings = {};
  closeDropdownSelectionProvinciaClient = false;

  public idDistritosClient: number;
  public itemNameDistritosClient: string;
  public selectedItemsDistritosClient = [];
  public DistritosListClient: any[] = new Array();
  public dropdownSettingsDistritosClient: IDropdownSettings = {};
  closeDropdownSelectionDistritosClient = false;

  public idCorregimientosClient: number;
  public itemNameCorregimientosClient: string;
  public selectedItemsCorregimientosClient = [];
  public CorregimientosListClient: any[] = new Array();
  public dropdownSettingsCorregimientosClient: IDropdownSettings = {};
  closeDropdownSelectionCorregimientosClient = false;

  public stepNR: number = 1;
  public nowDay: string;  

  public temp = [];
  public nextCursor: number | null = 0;
  public hasMore = true;

  public storeList: any[] = new Array();
  public storeListSelect: any[] = new Array();
  public selectedItemsStore = [];
  public storeInv: number;
  public dropdownSettingsStores = {
    singleSelection: true,
    badgeShowLimit: 1,
    text: "Seleccione Sucursal...",
    searchPlaceholderText: "Buscar",
    enableCheckAll: true,
    enableUnCheckAll: true,
    selectAllText: "Seleccionar todas",
    unSelectAllText: "Deseleccionar todas",
    enableSearchFilter: true,
    lazyLoading: false,
    noDataLabel: "Resultados:",
  };
  public companyAddDescription: number | boolean;

  public htmlGenerado : string;

  public dte: any;
  public fel: any;
  public felDetail: any;
  public companyLogoUrl: string;
  public CantidadEstuches: number;

  constructor(
    private cdref: ChangeDetectorRef,
    private _utilsService: UtilsService,
    private _companyService: CompanyService,
    private _warehouseService: WarehouseService,
    private _inventoryService: InventoryService,
    private _storeService: StoreService,
    private _invoiceService: InvoiceService,
    private _clientService: ClientService,
    private _representativeService: RepresentativeService,
    private _deliveryService: DeliveryService
  ) { }

  async ngOnInit() {
    // GET ID USER & ID COMPANY
    const _data = JSON.parse(localStorage.getItem('data'));
    this.userCode = _data.userCode ? parseInt(_data.userCode.toString()) : 0;
    this.storeCode = _data.storeCode ? parseInt(_data.storeCode.toString()) : 0;
    this.storeName = _data.storeName ? _data.storeName.toString() : '';
    this.companyCode = _data.companyCode ? parseInt(_data.companyCode.toString()) : 0;

    const _user = JSON.parse(localStorage.getItem('user'));
    this.userName = _user.userName ? _user.userName.toString() : '';
    this.transferHeader.transferAdviser = this.userName;

    this.price = null;
    this.total = 0;
    this.isEdit = false;
    this.addAmount = true;
    this.transferCode = 0;
    this.date = this._utilsService.dateTime('dd-MM-yyy');    
    this.transferDetail.transferNotaSalida = 0;
    this.transferDetail.transferSucursal = 0;
    this.transferDetail.transferInventoryDetailQuantity = 1;

    /*Datos iniciales shipment*/
    this.shipment.TipoTransaccionShipment = "Venta de Mercadería";
    this.shipment.MotivoEmision = "Traslado por Emisor Móvil";
    this.shipment.ResponsableEmision = "Emisor de la Factura";
    this.shipment.ObservacionesEmisor = "REMISIÓN PARA VENTAS DE MERCADERÍAS";
    this.shipment.InformacionInteresFisico = "JOYERÍA";
    this.shipment.PaisDestino = "PARAGUAY";
    this.shipment.TipoTransporte = "Propio";
    this.shipment.ModalidadTransporte = "TERRESTRE";
    this.shipment.ResponsableCostoFlete = "Transporte Propio";
    this.shipment.shipmentInternSerial = "A";
    this.shipment.NumeroCasaSalidaCliente = "0";
    this.shipment.CallePrincipalCliente = "Ciudad";
    this.shipment.NumeroCasaSalida = "0";
    this.shipment.CallePrincipal = "Ciudad";

    this.nowDay = this._utilsService.dateTime('yyy-MM-dd');
    this.shipment.FechaEmisionNR = this.nowDay;

    this.getAllClientsCompany();
    this.getSelectSetting(this.selectedItems);
    this.getSelectSettingSerial(this.selectedItemsSerial);
    this.getSelectSettingClient();
    this.getSelectSettingTransferType();
    this.getInventoryList(this.storeCode);
    await this.getCompany(this.companyCode);
    await this.getStore(this.storeCode);
    this.getAllTransferType();
    
    await this.getStoreByCompany(this.companyCode);

    await this.getAddresClientList(1, 0);
    this.getSelectSettingProvincia(this.selectedItemsProvincia);

    await this.getAllRepresentativesByCompany();
    this.getSelectSettingRepresentative();

    await this.getAddresClientListClient(1, 0);
    this.getSelectSettingProvinciaClient(this.selectedItemsProvincia);
  }
  ///////////////////////COMPANY///////////////////////
  getCompany(company) {
    return this._companyService.getOne(company).then(
      response => {
        if (response.result) {
          this.company = response.records[0];
          this.companyAddDescription = this.company.companyAddDescription;
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  ///////////////////////STORE///////////////////////
  getStore(store) {
    return this._storeService.getOne(store).then(
      response => {
        if (response.result) {
          this.store = response.records[0];
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  getAddresClientList(type, code) {

    let addresC ={
      type: type,
      code: code
    }

    return this._clientService.getAddressClient(addresC).then(
      response => {
        if (response.result) {

          if (type == 1) {
            this.ProvinciaList = response.records;
            console.log("ProvinciaList ->" + JSON.stringify(response.records));
          }
          else if (type == 2) {
            this.DistritosList = response.records;
            console.log("DistritosList ->" + JSON.stringify(response.records));
          }
          else if (type == 3) {
            this.CorregimientosList = response.records;
            console.log("CorregimientosList ->" + JSON.stringify(response.records));
          }
          
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  async onItemSelectProvincia(item: any) {
    console.log("---item---");
    console.log(item);
    const _selectedItemProvincia = await this.ProvinciaList.find(x => x.cod_provincia == item.cod_provincia);
    console.log(_selectedItemProvincia);    

    this.idProvincia = item.cod_provincia;
    this.itemNameProvincia = item.nombre;

    this.shipment.DeparamentoSalida = item.nombre;
    this.shipment.CodDeparamentoSalida = item.cod_provincia;

    await this.getAddresClientList(2, item.cod_provincia);
    this.getSelectSettingDistrito(this.selectedItemsDistritos);
  }

  async onItemSelectDistrito(item: any) {
    console.log("---item---");
    console.log(item);
    const _selectedItemDistrito = await this.DistritosList.find(x => x.id == item.id);
    console.log(_selectedItemDistrito);    

    this.idDistritos = item.cod_distrito;
    this.itemNameDistritos = item.nombre;

    this.shipment.DistritoSalida = item.nombre;
    this.shipment.CodDistritoSalida = item.cod_distrito;

    await this.getAddresClientList(3, this.idProvincia);
    this.getSelectSettingCorregimiento(this.selectedItemsCorregimientos);
  }

  async onItemSelectCorregimiento(item: any) {
    console.log("---item---");
    console.log(item);
    const _selectedItemCorregimiento = await this.CorregimientosList.find(x => x.id == item.id);
    console.log(_selectedItemCorregimiento);    

    this.idCorregimientos = item.cod_corregimiento;
    this.itemNameCorregimientos = item.nombre;

    this.shipment.CiudadSalida = item.nombre;
    this.shipment.CodCiudadSalida = item.cod_corregimiento;

    console.log('CodDireccion -> ', this.idProvincia, this.idDistritos, this.idCorregimientos);
    console.log('Descripcion -> ', this.itemNameProvincia, this.itemNameDistritos, this.itemNameCorregimientos);
  }

  getSelectSettingProvincia(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItemsProvincia = [selected] : '';

    this.dropdownSettingsProvincia = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'cod_provincia',
      textField: 'nombre'
    };
  }

  getSelectSettingDistrito(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItemsDistritos = [selected] : '';

    this.dropdownSettingsDistritos = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'cod_distrito',
      textField: 'nombre'
    };
  }

  getSelectSettingCorregimiento(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItemsCorregimientos = [selected] : '';

    this.dropdownSettingsCorregimientos = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'cod_corregimiento',
      textField: 'nombre'
    };
  }


  // DATA SELECT ADDRESS CLIENT
  getAddresClientListClient(type, code) {

    let addresC ={
      type: type,
      code: code
    }

    console.log("getAddresClientListClient -> ", addresC);

    return this._clientService.getAddressClient(addresC).then(
      response => {
        if (response.result) {

          if (type == 1) {
            this.ProvinciaListClient = response.records.map((item: any) => ({
              ...item,
              nombreCompleto: item.cod_provincia + ' - ' + item.nombre
            }));
            console.log("ProvinciaListClient ->" + JSON.stringify(response.records));
          }
          else if (type == 2) {
            this.DistritosListClient = response.records.map((item: any) => ({
              ...item,
              nombreCompleto: item.cod_distrito + ' - ' + item.nombre
            }));
            console.log("DistritosListClient ->" + JSON.stringify(response.records));
          }
          else if (type == 3) {
            this.CorregimientosListClient = response.records.map((item: any) => ({
              ...item,
              nombreCompleto: item.cod_corregimiento + ' - ' + item.nombre
            }));
            console.log("CorregimientosListClient ->" + JSON.stringify(response.records));
          }
          
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  async onItemSelectProvinciaClient(item: any) {
    console.log("---item provincia---");
    console.log(item);
    const _selectedItemProvinciaClient = await this.ProvinciaListClient.find(x => x.cod_provincia == item.cod_provincia);
    console.log(_selectedItemProvinciaClient);    

    this.idProvinciaClient = _selectedItemProvinciaClient.cod_provincia;
    this.itemNameProvinciaClient = _selectedItemProvinciaClient.nombre;

    console.log("DeparamentoSalidaCliente -> ", _selectedItemProvinciaClient.nombre, _selectedItemProvinciaClient.cod_provincia);

    this.loading = true;
    await this.getAddresClientListClient(2, _selectedItemProvinciaClient.cod_provincia);    
    this.getSelectSettingDistritoClient(this.selectedItemsDistritosClient);    

    this.idDistritosClient = 0;
    this.itemNameDistritosClient = "";
    this.idCorregimientosClient = 0;
    this.itemNameCorregimientosClient = "";
    this.selectedItemsDistritosClient = [];
    this.selectedItemsCorregimientosClient = [];
    this.loading = false;
  }

  async onItemSelectDistritoClient(item: any) {
    console.log("---item distrito---");
    console.log(item);

    const _selectedItemDistritoClient = await this.DistritosListClient.find(x => x.cod_distrito == item.cod_distrito);

    this.idDistritosClient = _selectedItemDistritoClient.cod_distrito;
    this.itemNameDistritosClient = _selectedItemDistritoClient.nombre;

    console.log("DistritoSalidaCliente -> ", _selectedItemDistritoClient.nombre, _selectedItemDistritoClient.cod_distrito);

    this.loading = true;
    await this.getAddresClientListClient(3, this.idProvinciaClient);
    this.getSelectSettingCorregimientoClient(this.selectedItemsCorregimientosClient);

    this.idCorregimientosClient = 0;
    this.itemNameCorregimientosClient = "";
    this.selectedItemsCorregimientosClient = [];
    this.loading = false;
  }

  async onItemSelectCorregimientoClient(item: any) {
    console.log("---item---");
    console.log(item);

    const _selectedItemCorregimientoClient = await this.CorregimientosListClient.find(x => x.cod_corregimiento == item.cod_corregimiento);

    this.idCorregimientosClient = _selectedItemCorregimientoClient.cod_corregimiento;
    this.itemNameCorregimientosClient = _selectedItemCorregimientoClient.nombre;

    console.log('CodDireccion -> ', this.idProvinciaClient, this.idDistritosClient, this.idCorregimientosClient);
    console.log('Descripcion -> ', this.itemNameProvinciaClient, this.itemNameDistritosClient, this.itemNameCorregimientosClient);
  }

  getSelectSettingProvinciaClient(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItemsProvinciaClient = [selected] : '';

    this.dropdownSettingsProvinciaClient = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'cod_provincia',
      textField: 'nombreCompleto'
    };
  }

  getSelectSettingDistritoClient(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItemsDistritosClient = [selected] : '';

    this.dropdownSettingsDistritosClient = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'cod_distrito',
      textField: 'nombreCompleto'
    };
  }

  getSelectSettingCorregimientoClient(selected) {
    // console.log(selected);
    Object.keys(selected).length > 0 ? this.selectedItemsCorregimientosClient = [selected] : '';

    this.dropdownSettingsCorregimientosClient = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'cod_corregimiento',
      textField: 'nombreCompleto'
    };
  }

  goBack() {
    this.stepNR--;
  }

  goNext() {
    this.stepNR++;
  }

  onChangeRazonTransfer(event) {
    this.transferHeader.transferRazon = event;
    console.log(this.transferHeader.transferRazon);

    if(this.transferHeader.transferRazon == 4){
      this.otherRazon = true;
    }
    else{
      this.otherRazon = false;
    }
  }

  ///////////////////////SELECT TRANSFER TYPES///////////////////////
  getSelectSettingTransferType() {
    this.dropdownSettingstransferType = {
      singleSelection: true,
      text: "Seleccione...",
      enableSearchFilter: true,
      lazyLoading: false,
    };
  }

  onItemSelectTransferType(item: any) {
    this.transferType = item.id;
    if(this.transferType == 2){
      this.RefNotaSalida = true;
    }
    else{
      this.RefNotaSalida = false;
    }
    console.log(this.transferType);
  }

  onDeSelectTransferType() {
    this.transferType = null;
  }

  getAllTransferType(){
    this.transferTypeList.push({
      id: "1",
      itemName: "Venta de Mercaderia"
    });

    // this.transferTypeList.push({
    //   id: "2",
    //   itemName: "Ingreso"
    // });
  }

  ///////////////////////SAVE MULTI STORE///////////////////////
  getStoreByCompany(companyCode) {
    return this._storeService.getAllByCompany(companyCode).then(
      (response) => {
        if (response.result) {
          for (const e of response.records) {
            this.storeList.push({ id: e.storeCode, itemName: e.storeName });
          }
        } else {
          console.log(response.message);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  onItemSelectStore(item: any) {
    this.storeListSelect.push({ inventoryStore: item.id });
    this.disabledMultiStore = false;
    console.log(item);
    this.storeInv = item.id;
    console.log(this.storeInv);
    this.transferDetail.transferSucursal = this.storeInv;
    console.log('transferSucursal',this.transferDetail.transferSucursal);
  }

  onSelectAllStore() {
    this.storeListSelect = [];
    this.storeList.forEach((x) => {
      this.storeListSelect.push({ inventoryStore: x.id });
    });
  }

  onDeItemSelectStore(item: any) {
    const find = this.storeListSelect.findIndex(
      (x) => x.inventoryStore === item.id
    );
    this.storeListSelect.splice(find, 1);

    this.storeListSelect.length == 0 ? (this.disabledMultiStore = true) : "";
  }

  onDeSelectAllStore() {
    this.storeListSelect = [];
    this.selectedItemsStore = null;
  }

  disabledMultiStore = false;

  ///////////////////////FUNCTION FOR SELECT///////////////////////  
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  getSelectSettingClient() {
    this.dropdownSettingsCliente = {
      singleSelection: true,
      text: "Seleccione...",
      enableSearchFilter: true,
      lazyLoading: false,
    };
  };

  getSelectSetting(selected) {
    Object.keys(selected).length > 0 ? this.selectedItems = [selected] : '';

    this.dropdownSettings = {
      singleSelection: true,
      searchPlaceholderText: 'Buscar...',
      closeDropDownOnSelection: true,
      allowSearchFilter: true,
      idField: 'id',
      textField: 'itemName'
    };
  }

  getSelectSettingSerial(selected) {
    Object.keys(selected).length > 0 ? this.selectedItemsSerial = [selected] : '';

    this.dropdownSettingsSerial = {
      // idField: 'InventorySerialCode',
      // textField: 'inventorySerialSerial',
      idField: 'serialCode',
      textField: 'description',
      itemsShowLimit: 3,
      enableCheckAll: false,
      singleSelection: false,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar",
    }
  }

  getAllClientsCompany() {

    return this._clientService.getAllByCompanyPaginated(this.companyCode, 10, 0).then(
      response => {
        if (response.result) {
          console.log(response.records);
          this.clientList = response.records;
          this.temp = this.clientList;
          this.nextCursor = response.nextCursor;
          this.hasMore = response.hasMore;

          console.log('NextCursor', this.nextCursor);
          console.log('HasMore', this.hasMore);

          const fetchMoreClients = async () => {
            while (this.hasMore) {
              try {
                const response = await this._clientService.getAllByCompanyPaginated(this.companyCode, 3500, this.nextCursor);
                if (response.result) {
                  this.clientList = this.clientList.concat(response.records);
                  this.temp = this.clientList;
                  this.nextCursor = response.nextCursor;
                  this.hasMore = response.hasMore;

                  console.log('NextCursor', this.nextCursor);
                  console.log('HasMore', this.hasMore);
                } else {
                  console.log(response.message);
                  break;
                }
              } catch (error) {
                console.log(error);
                break;
              }
            }

            this.clientList = [];
            console.log('response client', this.temp);
            this.temp.forEach(e => {
              this.clientList.push({
                id: e.clientCode,
                itemName: e.clientBusinessCode + ' - ' + e.clientName,
                phone: e.clientPhone,
                address: e.clientAddress,
                client: e.clientCode,
                nit: e.clientTaxDocument == null ? '' : e.clientTaxDocument,
                email: e.clientEmail,
                dv: e.clientDV
              });
            });

          };
          fetchMoreClients();

        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });

    // return this._clientService.getAllByCompany(this.companyCode).then(
    //   response => {
    //     if (response.result == true) {
    //       console.log('response client', response);
    //       response.records.forEach(e => {
    //         this.clientList.push({
    //           id: e.clientCode,
    //           itemName: e.clientBusinessCode + ' - ' + e.clientName,
    //           phone: e.clientPhone,
    //           address: e.clientAddress,
    //           client: e.clientCode,
    //           nit: e.clientTaxDocument == null ? '' : e.clientTaxDocument,
    //           email: e.clientEmail
    //         });
    //       });
    //     }
    //   },
    //   error => {
    //     console.log(error);
    //   }
    // );
  }

  getAllRepresentativesByCompany() {
    this.loading = true;
    return this._representativeService.getAll().then(
      response => {
        if (response.result) {
          // this.representativeList = response.records;
          response.records.forEach(e => {
            this.representativeList.push({
              id: e.CodeRepresentative,
              itemName: e.CodeRepresentative + ' - ' + e.NameRepresentative,
              additionalVehicle: e.AdditionalVehicle,
              IdRepresentative: e.IdRepresentative,
              NameRepresentative: e.NameRepresentative,
              AddressDriverRepresentative: e.AddressDriverRepresentative,
              BrandVehicle: e.BrandVehicle,
              FiscalAddressRepresentative: e.FiscalAddressRepresentative,
              NationalityRepresentative: e.NationalityRepresentative,
              NumberIdRepresentative: e.NumberIdRepresentative,
              NumberIdVehicle: e.NumberIdVehicle,
              TypeVehicle: e.TypeVehicle
            });
          });
          console.log('response representative', response);          
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  getSelectSettingRepresentative() {
    this.dropdownSettingsRepresentative = {
      singleSelection: true,
      text: "Seleccione...",
      enableSearchFilter: true,
      lazyLoading: false,
    };
  };

  onItemSelectRepresentative(item: any) {
    console.log("Representative selected:", item);
    this.shipment.TipoVehiculo = item.TypeVehicle;
    this.shipment.Marca = item.BrandVehicle;
    this.shipment.TipoIdentificacionVehiculo = "Numero de identificación del vehículo";
    this.shipment.ColorVehiculo = item.additionalVehicle;
    this.shipment.NumeroIdentificacionVehiculo = item.NumberIdVehicle;
    this.shipment.NaturalezaTransportista = "Contribuyente";
    this.shipment.NombreRazonEmpresa = this.company.companyName;
    this.shipment.RucEmpresa = this.company.companyTaxDocument;
    this.shipment.DigitoVerificador = "5";
    this.shipment.NacionalidadTransportista = item.NationalityRepresentative;
    this.shipment.NumeroDocumentoTransportista = item.NumberIdRepresentative;
    this.shipment.NombrePilot = item.NameRepresentative;
    this.shipment.DomicilioFiscalTransportista = item.FiscalAddressRepresentative;
    this.shipment.DireccionChofer = item.AddressDriverRepresentative;    
    // this.shipment.EmailCliente = item.email;
    // this.shipment.NombreCliente = item.itemName;
  }

  getInventoryList(company) {
    this.loading = true;

    this.inventoryList.push({
      id: 1,
      inventoryName: '1',
      inventoryDescription: '1',
      itemName: '1',
      inventoryPrice: 0,
      inventoryQuantity: 0,
      inventoryBusinessCode: 0,
      inventoryMin: 0,
      inventorySerialFlag: 0
    });
    this.inventoryList.push({
      id: 2,
      inventoryName: '2',
      inventoryDescription: '2',
      itemName: '2',
      inventoryPrice: 0,
      inventoryQuantity: 0,
      inventoryBusinessCode: 0,
      inventoryMin: 0,
      inventorySerialFlag: 0
    });
    this.inventoryList.push({
      id: 3,
      inventoryName: '3',
      inventoryDescription: '3',
      itemName: '3',
      inventoryPrice: 0,
      inventoryQuantity: 0,
      inventoryBusinessCode: 0,
      inventoryMin: 0,
      inventorySerialFlag: 0
    });
    this.inventoryList.push({
      id: 4,
      inventoryName: '4',
      inventoryDescription: '4',
      itemName: '4',
      inventoryPrice: 0,
      inventoryQuantity: 0,
      inventoryBusinessCode: 0,
      inventoryMin: 0,
      inventorySerialFlag: 0
    });
    this.inventoryList.push({
      id: 5,
      inventoryName: '5',
      inventoryDescription: '5',
      itemName: '5',
      inventoryPrice: 0,
      inventoryQuantity: 0,
      inventoryBusinessCode: 0,
      inventoryMin: 0,
      inventorySerialFlag: 0
    });

    this.loading = false;
    // return this._inventoryService.getAllByStore(company).then(
    //   response => {
    //     if (response.result) {
    //       // this.inventoryList = response.records;          
    //       console.log('response', response);
    //     } else {
    //       console.log(response.message);
    //     }
    //   },
    //   error => {
    //     console.log(error);
    //   }
    // ).finally(() => {
    //   this.loading = false;
    // });    
  }

  onItemSelectClient(item: any) {
    console.log("Client selected:", item);
    this.shipment.EmailCliente = item.email;
    this.shipment.NombreCliente = item.itemName;
    this.shipment.NaturalezaCliente = "2";
    this.shipment.TiOpeCliente = "2";
    this.shipment.PaisCliente = "PRY";
    this.shipment.DesPaisCliente = "Paraguay";
    this.shipment.TipoRec = "1";
    this.shipment.TipoRecDesc = "Cédula paraguaya";
    this.shipment.NumDocCliente = item.nit;
    this.shipment.CodCliente = item.id;
    this.shipment.DigitoVerificadorCliente = item.dv;
  }

  async onItemSelect(item: any) {
    console.log("Item selected:", item);
    this.transferDetail.transferInventoryDetailInventoryCode = item.id;
    const _selectedItem = this.inventoryList.find(x => x.id == item.id);
    this.price = _selectedItem.inventoryPrice;
    this.stock = _selectedItem.inventoryQuantity;
    this.transferDetail.description = _selectedItem.inventoryName;
    this.transferDetail.transferInventoryBussiness = _selectedItem.inventoryBusinessCode;
    this.Minstock = _selectedItem.inventoryMin;

    if (_selectedItem.inventorySerialFlag == 1) {
      let res_find = await this.transferLine.find(x => x.transferInventoryDetailInventoryCode === this.transferDetail.transferInventoryDetailInventoryCode);

      if (!res_find) {
        this.loading = true;
        this.serialList = [];
        const response = await this._inventoryService.getItemSerial(item.id);
        response.records[1].forEach(e => {
          this.serialList.push({
            serialCode: e.InventorySerialCode,
            description: e.inventorySerialSerial
          })
        });
        this.serial = true;
        this.loading = false;
      } else {
        await this.cleanLineTransfer();
        this._utilsService.showNotification(3, 'Item ya ingresado, por favor eliminalo antes.');
      }
    } else {
      this.serial = false
    }
  }

  onItemDeSelect(item: any) {
    this.serial = false;
    this.transferDetail.description = undefined;
  }

  onItemSelectSerial(item: any) {
    this.serialSelected.push({
      serialCode: item.serialCode,
      description: item.description
    });
  }

  onItemDeSelectSerial(item: any) {
    this.serialSelected.forEach((e, index) => {
      if (e.serialCode == item.serialCode) this.serialSelected.splice(index, 1);
    });
  }

  // GUARDAR UNA LINEA DE COMPRA
  async saveLine() {
    this.isDisabled = true;

    console.log("transferLine Ini", this.transferLine);

    if (this.transferDetail.transferInventoryDetailQuantity > 0) {

      await this.transferLine.push({
        transferInventoryDetailInventoryCode: 9999 + this.transferLine.length,
        transferInventoryDetailQuantity: 48 * this.transferDetail.transferInventoryDetailQuantity,
        transferInventoryBussiness: 9999 + this.transferLine.length,
        transferDetailType: 1,
        description: "101 - ARETES VARIOS MODELOS",
        unitPrice: 100000 * this.transferDetail.transferInventoryDetailQuantity,
        subtotal: 100000 * this.transferDetail.transferInventoryDetailQuantity,
      });

      await this.transferLine.push({
        transferInventoryDetailInventoryCode: 9999 + this.transferLine.length,
        transferInventoryDetailQuantity: 14 * this.transferDetail.transferInventoryDetailQuantity,
        transferInventoryBussiness: 9999 + this.transferLine.length,
        transferDetailType: 1,
        description: "102 - ANILLOS VARIOS MODELOS",
        unitPrice: 180000 * this.transferDetail.transferInventoryDetailQuantity,
        subtotal: 180000 * this.transferDetail.transferInventoryDetailQuantity,
      });

      await this.transferLine.push({
        transferInventoryDetailInventoryCode: 9999 + this.transferLine.length,
        transferInventoryDetailQuantity: 10 * this.transferDetail.transferInventoryDetailQuantity,
        transferInventoryBussiness: 9999 + this.transferLine.length,
        transferDetailType: 1,
        description: "103 - MEDALLAS VARIOS MODELOS",
        unitPrice: 150000 * this.transferDetail.transferInventoryDetailQuantity,
        subtotal: 150000 * this.transferDetail.transferInventoryDetailQuantity,
      });

      await this.transferLine.push({
        transferInventoryDetailInventoryCode: 9999 + this.transferLine.length,
        transferInventoryDetailQuantity: 10 * this.transferDetail.transferInventoryDetailQuantity,
        transferInventoryBussiness: 9999 + this.transferLine.length,
        transferDetailType: 1,
        description: "104 - CADENAS VARIOS MODELOS",
        unitPrice: 250000 * this.transferDetail.transferInventoryDetailQuantity,
        subtotal: 250000 * this.transferDetail.transferInventoryDetailQuantity,
      });

      await this.transferLine.push({
        transferInventoryDetailInventoryCode: 9999 + this.transferLine.length,
        transferInventoryDetailQuantity: 10 * this.transferDetail.transferInventoryDetailQuantity,
        transferInventoryBussiness: 9999 + this.transferLine.length,
        transferDetailType: 1,
        description: "105 - PULSERAS VARIOS MODELOS",
        unitPrice: 200000 * this.transferDetail.transferInventoryDetailQuantity,
        subtotal: 200000 * this.transferDetail.transferInventoryDetailQuantity,
      });

      console.log("transferLine Fin", this.transferLine);
      this.CantidadEstuches = this.transferDetail.transferInventoryDetailQuantity;

      //Actualizar?
      // let update = false;
      // this.transferLine.forEach((e) => {
      //   if (e.transferInventoryDetailInventoryCode == this.transferDetail.transferInventoryDetailInventoryCode) {
      //     let quantity = e.transferInventoryDetailQuantity + this.transferDetail.transferInventoryDetailQuantity;
      //     if (this.company.companyExistenceFlag == 1 || quantity <= this.stock) {
            
      //       //Restar Encabezado
      //       this.total = parseFloat((this.total - e.subtotal).toFixed(2));
      //       //Editar Linea
      //       e.transferInventoryDetailQuantity = quantity,
      //       e.subtotal = parseFloat((this.price * quantity).toFixed(2));
      //       //Sumar Encabezado 
      //       this.total = this.total + parseFloat((quantity * this.price).toFixed(2));
      //       this.addAmount = false;
      //       this.cleanLineTransfer();
      //     } else {
      //       this._utilsService.showNotification(2, 'Cantidad Excede Exitencia');
      //     }
      //     update = true;
      //     this.addAmount = false;
      //     this.isDisabled = false;
      //     this.cleanLineTransfer();
      //   }
      // });

      // //Nuevo Item
      // if (this.addAmount === true && update === false) {
      //   //Validacion
      //   if (this.company.companyExistenceFlag === 1 || this.transferDetail.transferInventoryDetailQuantity <= this.stock) {

      //     let DifInventario = this.stock - this.transferDetail.transferInventoryDetailQuantity;

      //     console.log(DifInventario, this.stock, this.transferDetail.transferInventoryDetailQuantity);
      //     console.log(this.Minstock);   

      //     if(DifInventario <= this.Minstock){
      //       this._utilsService.showNotification(2, 'El STOCK MINIMO ha llegado a su limite configurado.');
      //       //enviar correo
      //     }

      //     await this.transferLine.push({
      //       transferInventoryDetailInventoryCode: this.transferDetail.transferInventoryDetailInventoryCode,
      //       transferInventoryDetailQuantity: this.transferDetail.transferInventoryDetailQuantity,
      //       transferInventoryBussiness: this.transferDetail.transferInventoryBussiness,
      //       transferDetailType: 1,
      //       description: this.transferDetail.description,
      //       unitPrice: this.price,
      //       subtotal: this.price * this.transferDetail.transferInventoryDetailQuantity,
      //     });
      //     //Realizar Calculos
      //     this.total = this.total + parseFloat((this.transferDetail.transferInventoryDetailQuantity * this.price).toFixed(2));
      //     this.cleanLineTransfer();

      //   } else {
      //     this._utilsService.showNotification(2, 'Cantidad Excede Exitencia');
      //   }
      //   // this.isDisabled = false;
      // }
    } else {
      this._utilsService.showNotification(2, "Ingresa una cantidad")
    }

    this.isDisabled = false;
  }

  async cleanLine() {
    this.isDisabled = true;

    this.transferLine = [];

    this.isDisabled = false;
  }

  async saveLineDesc(){

    if(!this.transferDetail.description){
      this._utilsService.showNotification(2, "Ingresa una descripción")
      return;
    }

    await this.transferLine.push({
      transferInventoryDetailInventoryCode: 0,
      transferInventoryDetailQuantity: this.transferDetail.transferInventoryDetailQuantity,
      transferInventoryBussiness: 0,
      transferDetailType: 1,
      description: this.transferDetail.description,
      unitPrice: 0,
      subtotal: 0,
    });

    //Realizar Calculos
    this.total = this.total + parseFloat((this.transferDetail.transferInventoryDetailQuantity * this.price).toFixed(2));
    this.cleanLineTransfer();

  }

  async saveLineSerial() {
    this.isDisabled = true;
      if (this.transferDetail.transferInventoryDetailQuantity === this.serialSelected.length) { //serialSelectedTemp

        this.transferDetail.description += ' SERIE: ';
        for await (const e of this.serialSelected) {
          this.transferDetail.description += e.description + ', ';
        }

        await this.transferLine.push({
          transferInventoryDetailInventoryCode: this.transferDetail.transferInventoryDetailInventoryCode,
          transferInventoryDetailQuantity: this.transferDetail.transferInventoryDetailQuantity,
          transferInventoryBussiness: this.transferDetail.transferInventoryBussiness,
          transferDetailType: 0,
          description: this.transferDetail.description,
          unitPrice: this.price,
          subtotal: this.price * this.transferDetail.transferInventoryDetailQuantity,
          serial: this.serialSelected
        });
        this.total = this.total + parseFloat((this.transferDetail.transferInventoryDetailQuantity * this.price).toFixed(2));
        this.cleanLineTransfer();
      } else {
        this._utilsService.showNotification(2, 'Por favor revisa las cantidad de series seleccionadas');
      }
    this.isDisabled = false;
  }

  // ELIMINAR UNA LINEA
  deleteLine(item) {
    this.isDisabled = true;

    this.transferLine.forEach((e, index) => {
      if (e.transferInventoryDetailInventoryCode == item) {
        this.total = parseFloat((this.total - e.subtotal).toFixed(2));
        this.transferLine.splice(index, 1);
      }
    })
    this.cleanLineTransfer();
    this.isDisabled = false;
  }

  // LIMPIAR LINEA PARA NUEVO INGRESO
  cleanLineTransfer() {
    this.addAmount = true;
    this.selectedItems = []; 
    //this.transferDetail = {} as transferDetail;
    this.serialSelected = [];
    this.serial = false;
    this.selectedItemsSerial = [];
    this.transferDetail.transferInventoryDetailQuantity = null;
    this.transferDetail.description = '';
    this.price = null;
  }

  async save() {

    this.loading = true;
    this.isDisabled = true;

    console.log("shipment Json", this.shipment);

    let json

    json = {
      "store": {
        "storeCode": this.storeCode
      },
      "user": {
        "userCode": this.userCode
      },
      "transmitter": {
        "transmitterMembership": "REG",
        "transmitterType": "FACT",
        "transmitterEstablishmentCode": this.store.storeEstablishmentCode,
        "transmitterExpeditionPoint": 1,
        "transmitterEmail": this.company.companyEmail,
        "transmitterTaxDocument": this.company.companyTaxDocument,
        "transmitterComercialName": this.store.storeName,
        "transmitterName": this.company.companyName,
        "transmitterAddress": this.store.storeAddress,
        "transmitterZipCode": this.store.storeZipCode,
        "transmitterMunicipality": this.store.storeMunicipality,
        "transmitterDepartment": this.store.storeDepartment,
        "transmitterCountry": 'PA',
        "transmitterPrefix": this.company.companyPrefix,
        "transmitterUser": this.company.companyPrefix,
        "transmitterKey": this.company.companyKey,
        "transmitterToken": this.company.companyToken,
        "transmitterPhraseCode": parseFloat(this.company.companyPhraseCode),
        "transmitterPhraseType": parseFloat(this.company.companyPhraseType),
        "transmitterPhone": this.company.companyPhone,
      },
      "receiver": {
        "receiverAddress": this.shipment.CallePrincipalCliente,
        "receiverCode": this.shipment.CodCliente,
        "receiverDeleted": 0,
        "receiverEmail": this.shipment.EmailCliente,
        "receiverName": this.shipment.NombreCliente,
        "receiverStatus": 1,
        "receiverTaxDocument": this.shipment.NumDocCliente,
        "receiverTypeTaxDocument": "0", //this.tipoCliente,
        "receiverZipCode": 0,
        "receiverCountry": "PY",
        "receiverPhone": this.shipment.TelefonoCliente == "" ? "00000000" : this.shipment.TelefonoCliente,
        "receiverDV": this.client.clientDV,
        "receiverTR": this.client.clientTR,
        "receiverDOperacion": this.client.clientDOperacion,
        "receiverProvincia": this.idProvinciaClient,
        "receiverDistrito": this.idDistritosClient,
        "receiverCorregimiento": this.idCorregimientosClient,
        "receiverDesProvincia": this.itemNameProvinciaClient,
        "receiverDesDistrito": this.itemNameDistritosClient,
        "receiverDesCorregimiento": this.itemNameCorregimientosClient,        
        "receiverCodeUbicacion": this.idProvinciaClient + "-" + this.idDistritosClient + "-" + this.idCorregimientosClient,
      },
      "shipment": this.shipment,
      "phrase": this.company.phrase,
      "detail": this.transferLine,
      "logoUrl": '',
      "cantidadEstuches": this.CantidadEstuches
    };

    console.log("shipment sign Json", json);

    const logo = await this._companyService.getOne(this.companyCode);
    logo.records[0].companyLogoUrl != 'undefined' && (this.companyLogoUrl = logo.records[0].companyLogoUrl);
    json.logoUrl = this.companyLogoUrl || '';

    // const logo = await this._companyService.getOne(this.companyCode);
    // logo.records[0].companyLogoUrl != 'undefined' && (this.company.companyLogoUrl = logo.records[0].companyLogoUrl);

    // const CDC = "0780 1279 8950 0100 1000 0001 2202 6010 6183 5553 9662";
    // this._printService.noteShipment(json, json.detail, this.company, CDC);    


    // this.loading = false;
    // this.isDisabled = false;
    // return;

    this._deliveryService.insertDelivery(json).then(
        async (response) => {
          console.log('response Insert Delivery', response);
          console.log('response Insert Delivery 2', response.records.infileServiceResponse.data);
          console.log('response Insert Delivery 3', response.records.infileServiceResponse.data.data);
          console.log('response Insert Delivery 4', response.records.infileServiceResponse.data.data.ok);

          /*Mega*/
          // if (response.result) {

          //   this._utilsService.showNotification(1, response.message);

          //   if(response.records.invoiceGetFile.status){
          //     this._utilsService.showNotification(1, response.records.invoiceGetFile.message);
          //     window.open(response.records.invoiceGetFile.url.url, '_self', 'width=600,height=600');
          //     const CDC = response.records.infileServiceResponse.data.CDC;
          //   }
          //   else{
          //     this._utilsService.showNotification(3, response.records.invoiceGetFile.message);
          //   }

          //   this.cleanModel();
          // }
          /*Fin Mega*/
          /*Dnit*/
          if (response.records.infileServiceResponse.data.data.ok) {

            // this._utilsService.showNotification(1, response.message);

            // if(response.records.invoiceGetFile.status){
            //   this._utilsService.showNotification(1, response.records.invoiceGetFile.message);
            //   window.open(response.records.invoiceGetFile.url.url, '_self', 'width=600,height=600');
            //   const CDC = response.records.infileServiceResponse.data.CDC;
            // }
            // else{
            //   this._utilsService.showNotification(3, response.records.invoiceGetFile.message);
            // }

            console.log('Response PY', response);

            this._utilsService.showNotification(1, response.message);
            this._utilsService.showNotification(1, response.records.infileServiceResponse.data.msgRes);

            this.fel = response.infileBody;
            this.felDetail = response.infileBody.detail;
            this.dte = {
              serie: response.records.infileServiceResponse.data.CDC,
              noFactura: response.records.infileServiceResponse.data.protConsLote,
              autorizacion: response.invoiceAuthorization,
              certificador: "DNIT",
              nitCertificador: 12345678,
              fechaCertificacion: response.records.infileServiceResponse.data.fecProc
            }
            console.log("QR", response.records.infileServiceResponse.data.qrUrl);
            const CDC = response.records.infileServiceResponse.data.data.CDC;
            this.downloadUrlS3(response.records.infileServiceResponse.data.data.signedUrl, CDC, "xml");
            if (response.records.infileServiceResponse.data.data.signedUrlPdf) {
              this.downloadUrlS3(response.records.infileServiceResponse.data.data.signedUrlPdf, CDC, "pdf");
            }
            this.cleanModel();

          }
          /*Fin Dnit*/
          else{
            console.log ('Error en delivery');
            this._utilsService.showNotification(3, response.message);/*Dnit*/
            // this._utilsService.showNotification(3, response.errorMessage);/*Mega*/
          }          

        },
        error => {

          this._utilsService.showNotification(2, error);
          console.log(error);

        }
      ).finally(() => {

        this.loading = false;
        this.isDisabled = false;

      });

    return;

    if (this.transferHeader.transferWarehouseCode > 0 && this.transferLine.length > 0) {
      this.loading = true;
      this.isDisabled = true;

      const json = {
        "header": {
          "transferOriginStoreCode": this.storeCode,
          "transferWarehouseCode": this.transferHeader.transferWarehouseCode,
          "transferDescription": "Envio de Mercancia",
          "transferUserCode": this.userCode,
          "transferType": 3,
          "transferRazon": this.transferHeader.transferRazon,
          "transOtherRazonDesc": this.transferHeader.transOtherRazonDesc,
          "transferNotaSalidaRef": this.transferDetail.transferNotaSalida,
          "transferSucursalOrg": this.transferDetail.transferSucursal,
          "shipmentNamePilot": this.NombrePilot,
          "shipmentDPIPilot": this.DPIPilot,
          "shipmentTelPilot": this.TelPilot,
          "shipmentDirPilot": this.DirPilot,
          "shipmentMarcaCarro": this.MarcaCarro,
          "shipmentModeloCarro": this.ModeloCarro,
          "shipmentPlacaCarro": this.PlacaCarro,
          "shipmentColorCarro": this.ColorCarro,
        },
        "detail": this.transferLine,
      };

      const logo = await this._companyService.getOne(this.companyCode);
      logo.records[0].companyLogoUrl != 'undefined' && (this.company.companyLogoUrl = logo.records[0].companyLogoUrl);

      console.log('json save', json);
      
      //* Insertar Transferencia    
      this._warehouseService.insertTransfer(json).then(
        async (response) => {
          if (response.result) {
            this.transferCode =  response.transferencia;
            
            const transfer = {
              transferBusinessCode: response.transferencia,
              bodega: this.transferHeader.transferName,
              clientTaxDocument: this.transferHeader.transferTaxDocument,
              direccion: this.transferHeader.transferAddress,
              fecha: this.date,
              warehousePhone: this.transferHeader.transferPhone,
              usuario: this.transferHeader.transferAdviser,
              transferRazon: this.transferHeader.transferRazon,
              transOtherRazonDesc: this.transferHeader.transOtherRazonDesc,
              transferType: this.transferType,
              shipmentNamePilot: this.NombrePilot,
              shipmentDPIPilot: this.DPIPilot,
              shipmentTelPilot: this.TelPilot,
              shipmentDirPilot: this.DirPilot,
              shipmentMarcaCarro: this.MarcaCarro,
              shipmentModeloCarro: this.ModeloCarro,
              shipmentPlacaCarro: this.PlacaCarro,
              shipmentColorCarro: this.ColorCarro,
            }

            const detail = this.transferLine.map(function(x) {        
              const result = {
                code: x.transferInventoryBussiness,
                quantity: x.transferInventoryDetailQuantity,
                description: x.description,
                unitPrice: x.unitPrice,
                subtotal: x.subtotal
              }
              return result;
            }); 
            this._utilsService.showNotification(1, response.message);
            //this._printService.noteTransfer(transfer, detail, this.company);
            
            // if(this.companyCode == 22){
            //   this._printService.noteTransferNail(transfer, detail, this.company);
            // }
            // else{
            //   this._printService.noteShipment(transfer, detail, this.company);
            // }

            // this._printService.noteShipment(transfer, detail, this.company);

            if(1 == 1){
              // const pdfHmtl = this._printService.noteTransferEmail(transfer, detail, this.company);

              var typeTransfer = this.transferType == 1 ? 'Salida' : 'Ingreso';
              // const pdfHtml = `
              //   <html>
              //     <head>
              //       <title>Reporte de Transferencia</title>
              //     </head>
              //     <body>
              //       <h1>Reporte de Creación de Transferencia</h1>
              //       <p>Se ha generado la transferencia No. ` + this.transferCode + `</p>                    
              //     </body>
              //   </html>
              // `;

              let tableRows = '';

              tableRows += `<tr><td>${typeTransfer}</td><td>${this.storeName}</td><td>${transfer.usuario}</td></tr>`;

              const pdfHtml = `
                <html>
                  <head>
                    <title>Reporte de Transferencias</title>
                  </head>
                  <body>
                    <h1>Reporte de Creación de Transferencia</h1>
                    <p>Se ha generado la transferencia No. ` + transfer.transferBusinessCode + `</p>
                    <table style="border: 1px solid black;">
                      <thead>
                        <tr style="border: 1px solid black;">
                          <th>Tipo</th>
                          <th>Sucursal</th>
                          <th>Asesor</th>
                        </tr>
                      </thead>
                      <tbody style="border: 1px solid black;">
                        ${tableRows}
                      </tbody>
                    </table>
                  </body>
                </html>
              `;

              //ENVIAR PREVENTA POR CORREO
              const data_to_send = {
                email: "jearson.developer11@gmail.com; administrador@clever.com.gt",
                presale_number: "",
                html_content: pdfHtml,
              };

              this._invoiceService
                .sendEmail_Presale(data_to_send)
                .then(
                  async (response) => {
                    if (response) {
                      this._utilsService.showNotification( 1, "Notificación enviada correctamente");
                    }
                  },
                  (error) => {
                    console.log(error);
                    //this.loading = false;
                    //this.disabled = false;
                  }
                );

            }

            this.cleanModel();
          } else {
            this._utilsService.showNotification(3, response.errorMessage);
          }
        },
        error => {
          this._utilsService.showNotification(2, error);
          console.log(error);
        }
      ).finally(() => {
        this.loading = false;
        this.isDisabled = false;
      });
      //*/
    } else {
      this._utilsService.showNotification(2, 'Falto llenar datos');
    }
  }

  async downloadUrlS3(urlFirmada, nombreFile, format){
    const response = await fetch(urlFirmada);
    const blob = await response.blob();

    const urlBlob = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = urlBlob;
    link.download = nombreFile + "." + format;
    link.click();

    window.URL.revokeObjectURL(urlBlob);
  }

  // Limpiar Campos
  cleanModel() {
    this.transferCode = 0;
    this.addAmount = true;
    this.isDisabled = false;
    this.transferHeader = {} as transferHeader;
    this.transferDetail = {} as transferDetail;
    this.transferLine = [];
    this.total = 0;
    this.price = 0;
    this.transferHeader.transferAdviser = this.userName;
    this.selectedItems = [];
    this.selectedItemsClient = [];
    this.selectedItemsrepresentative = [];
    this.selectedItemsStore = [];
    this.transferDetail.transferNotaSalida = 0;
    this.transferDetail.transferSucursal = 0;
    this.NombrePilot = "";
    this.DPIPilot = "";
    this.TelPilot = "";
    this.DirPilot = "";
    this.MarcaCarro = "";
    this.ModeloCarro = "";
    this.PlacaCarro = "";
    this.ColorCarro = "";
    this.transferDetail.transferInventoryDetailQuantity = 1;
    this.shipment = {} as shipment;

    /*Datos iniciales shipment*/
    this.shipment.TipoTransaccionShipment = "Venta de Mercadería";
    this.shipment.MotivoEmision = "Traslado por Emisor Móvil";
    this.shipment.ResponsableEmision = "Emisor de la Factura";
    this.shipment.ObservacionesEmisor = "REMISIÓN PARA VENTAS DE MERCADERÍAS";
    this.shipment.InformacionInteresFisico = "JOYERÍA";
    this.shipment.PaisDestino = "PARAGUAY";
    this.shipment.TipoTransporte = "Propio";
    this.shipment.ModalidadTransporte = "TERRESTRE";
    this.shipment.ResponsableCostoFlete = "Transporte Propio";
    this.shipment.shipmentInternSerial = "A";
    this.shipment.NumeroCasaSalidaCliente = "0";
    this.shipment.CallePrincipalCliente = "Ciudad";
    this.shipment.NumeroCasaSalida = "0";
    this.shipment.CallePrincipal = "Ciudad";
    this.shipment.FechaEmisionNR = this.nowDay;

    this.selectedItemsProvincia = [];
    this.selectedItemsDistritos = [];
    this.selectedItemsCorregimientos = [];

    this.selectedItemsProvinciaClient = [];
    this.selectedItemsDistritosClient = [];
    this.selectedItemsCorregimientosClient = [];
    this.stepNR = 1;

    this.idDistritosClient = 0;
    this.idProvinciaClient = 0;
    this.idCorregimientosClient = 0;
    this.itemNameProvinciaClient = "";
    this.itemNameDistritosClient = "";
    this.itemNameCorregimientosClient = "";
  }
}
